import { MFA_FACTOR_IDS } from '../constants';
import { determineIfMFAMethodIsMandatory } from './determineIfMFAMethodIsMandatory';

/**
 * @satisfies {FactorId[]}
 */
const MFA_METHODS = [MFA_FACTOR_IDS.TOTP, MFA_FACTOR_IDS.PHONE];

/**
 * Returns the mandatory MFA Factor Ids for a user.
 *
 * @param {Object} params
 * @param {UserType | ""} params.userType
 * @returns {FactorId[]}
 */
export const getMandatoryMFAFactorIds = ({ userType }) =>
  MFA_METHODS.filter((method) => determineIfMFAMethodIsMandatory({ method, userType }));
